module.exports = __webpack_public_path__ + "static/media/csv.6cc3ed95.svg";